import { render, staticRenderFns } from "./CardExtras.vue?vue&type=template&id=a849cce8&scoped=true&"
import script from "./CardExtras.vue?vue&type=script&lang=js&"
export * from "./CardExtras.vue?vue&type=script&lang=js&"
import style0 from "./CardExtras.vue?vue&type=style&index=0&id=a849cce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a849cce8",
  null
  
)

export default component.exports